import { render, staticRenderFns } from "./EnviosDePush.vue?vue&type=template&id=5b054130&"
import script from "./EnviosDePush.vue?vue&type=script&lang=js&"
export * from "./EnviosDePush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports